// @flow
import React, { type Element } from 'react';
import { compose, pure } from 'recompose';
import { Button } from 'angieslist-react-components';
import { analyticsActions, Track } from 'angieslist-app-platform';
import { defaultProps } from '../../../../app/browser/analyticsDefaultProperties';
import SendEnhancedTrackEventOnce from '../../../../app/browser/SendEnhancedTrackEventOnce';
import './profileIncompleteCard.scss';

type Props = {
 serviceProviderId: string,
 sendEnhancedTrackEvent:
  typeof analyticsActions.sendEnhancedTrackEvent,
}

export const ProfileIncompleteCard = (props: Props) : Element<"div"> => {
  const {
    serviceProviderId,
    sendEnhancedTrackEvent,
  } = props;

  const cardsEventProps = {
    ...defaultProps,
    activityLocation: 'SP : Home',
    impressionTracking: 'ProfileIncomplete',
    description: 'View cards',
  };

  const redirectToStep1 = () => {
    window.location.href = `/app/setup/${serviceProviderId}/about`;
  };

  return (
    <div id="profile-incomplete--container">
      <SendEnhancedTrackEventOnce
        analyticsEventName="Item Clicked"
        analyticsEventProperties={cardsEventProps}
        sendEnhancedTrackEvent={sendEnhancedTrackEvent}
      />
      <div id="profile-incomplete--title-container">
        <div
          id="profile-incomplete--title"
          className="National2-Bold"
        >
          Complete your profile
        </div>
        <div
          id="profile-incomplete--caption"
          className="National2-Regular"
        >
          Take 3 minutes to wrap up your profile and start getting more views.
        </div>
      </div>
      <div className="profile-incomplete--progress-bar" />
      <Track>
        <Button id="profile-incomplete--finish-profile-button-container" onClick={redirectToStep1}>
          <div
            id="profile-incomplete--finish-profile-button"
            className="National2-Bold"
          >
            Finish profile
          </div>
        </Button>
      </Track>
    </div>
  );
};

export default (compose(pure)(ProfileIncompleteCard): any);



// WEBPACK FOOTER //
// ./src/modules/home/browser/components/profileIncompleteCard.js